import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequestHeader } from '@tanstack/react-start/server';
import { isMobile } from '@/utils/isMobile';
import type { Device } from '../types';

// Resolve the web/mweb variant from the client's User-Agent — ISOMORPHIC so the
// server request header shapes the SSR HTML and client navigations use the
// browser's navigator.userAgent. A cold WebView may occasionally omit the UA;
// CBCC is mobile-first, so that missing-UA case deliberately defaults to mweb
// instead of the old desktop fallback.
//
// Call this in the LOADER so the answer rides the dehydrated loader data and
// hydration reuses the server-selected variant verbatim.
export function resolveDeviceFromUserAgent(
	userAgent: string | undefined,
): Device {
	if (!userAgent) return 'mweb';
	return isMobile(userAgent) ? 'mweb' : 'web';
}

export const resolveDevice = createIsomorphicFn()
	.server(
		(): Device =>
			resolveDeviceFromUserAgent(getRequestHeader('User-Agent') ?? undefined),
	)
	.client(
		(): Device =>
			resolveDeviceFromUserAgent(window.navigator.userAgent || undefined),
	);
